var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g3, _path17, _g4, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoReffrenceAd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 257,
    height: 247,
    viewBox: "0 0 257 247",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.701 245.845C191.049 245.845 242.402 194.492 242.402 131.144C242.402 67.7968 191.049 16.4434 127.701 16.4434C64.3533 16.4434 12.9999 67.7968 12.9999 131.144C12.9999 194.492 64.3533 245.845 127.701 245.845Z",
    fill: "url(#paint0_linear_618_80585)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M189.581 43.1338H62.5168C54.5967 43.1338 48.1761 49.5543 48.1761 57.4744H203.922C203.922 49.5543 197.501 43.1338 189.581 43.1338Z",
    fill: "url(#paint1_linear_618_80585)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1761 57.083H203.922V175.702C203.922 180.975 201.827 186.033 198.098 189.762C194.369 193.492 189.311 195.587 184.037 195.587H68.0613C62.7874 195.587 57.7295 193.492 54.0004 189.762C50.2712 186.033 48.1761 180.975 48.1761 175.702V57.083Z",
    fill: "url(#paint2_linear_618_80585)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.15 72.0654H74.9983C72.8709 72.0654 71.1464 73.7881 71.1464 75.9132C71.1464 78.0383 72.8709 79.761 74.9983 79.761H177.15C179.278 79.761 181.002 78.0383 181.002 75.9132C181.002 73.7881 179.278 72.0654 177.15 72.0654Z",
    fill: "url(#paint3_linear_618_80585)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.15 104.761H74.9983C72.8709 104.761 71.1464 106.483 71.1464 108.609C71.1464 110.734 72.8709 112.456 74.9983 112.456H177.15C179.278 112.456 181.002 110.734 181.002 108.609C181.002 106.483 179.278 104.761 177.15 104.761Z",
    fill: "url(#paint4_linear_618_80585)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.15 137.456H74.9983C72.8709 137.456 71.1464 139.179 71.1464 141.304C71.1464 143.429 72.8709 145.152 74.9983 145.152H177.15C179.278 145.152 181.002 143.429 181.002 141.304C181.002 139.179 179.278 137.456 177.15 137.456Z",
    fill: "url(#paint5_linear_618_80585)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M177.15 170.152H74.9984C72.8711 170.152 71.1465 171.875 71.1465 174C71.1465 176.125 72.8711 177.848 74.9984 177.848H177.15C179.278 177.848 181.002 176.125 181.002 174C181.002 171.875 179.278 170.152 177.15 170.152Z",
    fill: "url(#paint6_linear_618_80585)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_618_80585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.3065 130.443H19.9122C15.5424 130.443 11.9999 133.986 11.9999 138.356V216.104C11.9999 220.473 15.5424 224.016 19.9122 224.016H74.3065C78.6764 224.016 82.2189 220.473 82.2189 216.104V138.356C82.2189 133.986 78.6764 130.443 74.3065 130.443Z",
    fill: "url(#paint7_linear_618_80585)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_618_80585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.15 9H169.069C166.269 9 164 11.2696 164 14.0692V42.3086C164 45.1083 166.269 47.3778 169.069 47.3778H229.15C231.949 47.3778 234.219 45.1083 234.219 42.3086V14.0692C234.219 11.2696 231.949 9 229.15 9Z",
    fill: "url(#paint8_linear_618_80585)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2368 169.338H25.9819C24.5591 169.338 23.4056 170.491 23.4056 171.914V171.923C23.4056 173.345 24.5591 174.499 25.9819 174.499H68.2368C69.6596 174.499 70.8131 173.345 70.8131 171.923V171.914C70.8131 170.491 69.6596 169.338 68.2368 169.338Z",
    fill: "url(#paint9_linear_618_80585)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2608 205.653H26.3691C24.9585 205.653 23.8149 206.771 23.8149 208.149V208.157C23.8149 209.536 24.9585 210.653 26.3691 210.653H68.2608C69.6714 210.653 70.8149 209.536 70.8149 208.157V208.149C70.8149 206.771 69.6714 205.653 68.2608 205.653Z",
    fill: "url(#paint10_linear_618_80585)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2608 186.653H26.3691C24.9585 186.653 23.8149 187.771 23.8149 189.149V189.157C23.8149 190.536 24.9585 191.653 26.3691 191.653H68.2608C69.6714 191.653 70.8149 190.536 70.8149 189.157V189.149C70.8149 187.771 69.6714 186.653 68.2608 186.653Z",
    fill: "url(#paint11_linear_618_80585)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4317 142.45H29.0837C26.3485 142.45 24.1312 144.668 24.1312 147.403V150.829C24.1312 153.565 26.3485 155.782 29.0837 155.782H41.4317C44.1669 155.782 46.3842 153.565 46.3842 150.829V147.403C46.3842 144.668 44.1669 142.45 41.4317 142.45Z",
    fill: "url(#paint12_linear_618_80585)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178.828 34.0124C182.047 34.0124 184.656 31.4031 184.656 28.1844C184.656 24.9657 182.047 22.3564 178.828 22.3564C175.609 22.3564 173 24.9657 173 28.1844C173 31.4031 175.609 34.0124 178.828 34.0124Z",
    fill: "#81D5E7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M199.655 34.0124C202.874 34.0124 205.483 31.4031 205.483 28.1844C205.483 24.9657 202.874 22.3564 199.655 22.3564C196.436 22.3564 193.827 24.9657 193.827 28.1844C193.827 31.4031 196.436 34.0124 199.655 34.0124Z",
    fill: "#81D5E7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M220.482 34.0124C223.701 34.0124 226.31 31.4031 226.31 28.1844C226.31 24.9657 223.701 22.3564 220.482 22.3564C217.263 22.3564 214.654 24.9657 214.654 28.1844C214.654 31.4031 217.263 34.0124 220.482 34.0124Z",
    fill: "#81D5E7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M204.681 173.017L189.92 189.289L231.525 227.027L246.285 210.754L204.681 173.017Z",
    fill: "url(#paint13_linear_618_80585)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.279 146.083C220.279 180.126 192.682 207.723 158.64 207.723C124.597 207.723 96.9999 180.126 96.9999 146.083C96.9999 112.04 124.597 84.4434 158.64 84.4434C192.682 84.4434 220.279 112.04 220.279 146.083ZM210.824 146.083C210.824 174.904 187.46 198.268 158.639 198.268C129.818 198.268 106.454 174.904 106.454 146.083C106.454 117.262 129.818 93.8982 158.639 93.8982C187.46 93.8982 210.824 117.262 210.824 146.083Z",
    fill: "url(#paint14_linear_618_80585)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_618_80585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.64 198.268C187.461 198.268 210.825 174.904 210.825 146.083C210.825 117.262 187.461 93.8984 158.64 93.8984C129.819 93.8984 106.455 117.262 106.455 146.083C106.455 174.904 129.819 198.268 158.64 198.268Z",
    fill: "url(#paint15_linear_618_80585)",
    fillOpacity: 0.2
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M171.179 146.083L186.104 131.125C187.502 129.645 188.268 127.679 188.239 125.643C188.21 123.608 187.389 121.664 185.949 120.224C184.51 118.784 182.565 117.963 180.53 117.934C178.494 117.905 176.528 118.671 175.048 120.07L160.09 135.027L145.166 120.07C144.448 119.31 143.585 118.701 142.627 118.281C141.67 117.86 140.638 117.636 139.592 117.621C138.547 117.606 137.509 117.801 136.54 118.194C135.571 118.588 134.691 119.171 133.952 119.911C133.212 120.65 132.629 121.53 132.235 122.499C131.842 123.468 131.647 124.506 131.662 125.552C131.677 126.597 131.901 127.629 132.322 128.586C132.742 129.544 133.35 130.407 134.11 131.125L149.06 146.083L134.11 161.04C133.35 161.759 132.742 162.622 132.322 163.579C131.901 164.537 131.677 165.569 131.662 166.614C131.647 167.66 131.842 168.698 132.235 169.666C132.629 170.635 133.212 171.516 133.952 172.255C134.691 172.994 135.571 173.578 136.54 173.971C137.509 174.365 138.547 174.56 139.592 174.545C140.638 174.53 141.67 174.306 142.627 173.885C143.585 173.464 144.448 172.856 145.166 172.096L160.124 157.138L175.081 172.096C176.575 173.412 178.514 174.108 180.504 174.044C182.493 173.979 184.383 173.159 185.789 171.749C187.194 170.339 188.009 168.447 188.068 166.457C188.126 164.467 187.424 162.53 186.104 161.04L171.179 146.083Z",
    fill: "url(#paint16_linear_618_80585)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_618_80585)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 160.365,
    cy: 174.907,
    rx: 36.6853,
    ry: 5.41942,
    fill: "#EC5575",
    fillOpacity: 0.56
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M117.968 210.904C118.486 208.76 121.535 208.76 122.053 210.904L123.795 218.12C123.98 218.886 124.578 219.485 125.344 219.669L132.56 221.411C134.704 221.929 134.704 224.979 132.56 225.496L125.344 227.238C124.578 227.423 123.98 228.021 123.795 228.787L122.053 236.003C121.535 238.147 118.486 238.147 117.968 236.003L116.226 228.787C116.041 228.021 115.443 227.423 114.677 227.238L107.461 225.496C105.317 224.979 105.317 221.929 107.461 221.411L114.677 219.669C115.443 219.485 116.041 218.886 116.226 218.12L117.968 210.904Z",
    fill: "url(#paint17_linear_618_80585)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9679 18.9041C35.4854 16.7601 38.5351 16.7601 39.0526 18.9041L40.7945 26.1201C40.9795 26.8863 41.5777 27.4845 42.3439 27.6695L49.5599 29.4114C51.7039 29.9289 51.7039 32.9786 49.5599 33.4961L42.3439 35.238C41.5777 35.423 40.9795 36.0212 40.7945 36.7874L39.0526 44.0034C38.5351 46.1474 35.4854 46.1474 34.9679 44.0034L33.226 36.7874C33.041 36.0212 32.4428 35.423 31.6766 35.238L24.4606 33.4961C22.3166 32.9786 22.3166 29.9289 24.4606 29.4114L31.6766 27.6695C32.4428 27.4845 33.041 26.8863 33.226 26.1201L34.9679 18.9041Z",
    fill: "url(#paint18_linear_618_80585)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.128 20.0731C125.062 20.0731 126.63 18.5053 126.63 16.5714C126.63 14.6374 125.062 13.0697 123.128 13.0697C121.194 13.0697 119.626 14.6374 119.626 16.5714C119.626 18.5053 121.194 20.0731 123.128 20.0731ZM123.128 22.6994C126.512 22.6994 129.256 19.9558 129.256 16.5714C129.256 13.187 126.512 10.4434 123.128 10.4434C119.743 10.4434 117 13.187 117 16.5714C117 19.9558 119.743 22.6994 123.128 22.6994Z",
    fill: "url(#paint19_linear_618_80585)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M232.014 116.497C231.681 115.191 232.887 114.014 234.185 114.379L242.943 116.84C244.241 117.205 244.657 118.837 243.692 119.779L237.181 126.133C236.217 127.074 234.595 126.619 234.262 125.313L232.014 116.497Z",
    fill: "url(#paint20_linear_618_80585)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7127 101.462C28.0192 101.13 29.1944 102.338 28.828 103.635L26.3554 112.39C25.9891 113.687 24.356 114.101 23.4159 113.135L17.0699 106.616C16.1297 105.651 16.5876 104.029 17.8941 103.698L26.7127 101.462Z",
    fill: "url(#paint21_linear_618_80585)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M193.713 222.462C195.019 222.13 196.194 223.338 195.828 224.635L193.356 233.39C192.989 234.687 191.356 235.101 190.416 234.135L184.07 227.616C183.13 226.651 183.588 225.029 184.894 224.698L193.713 222.462Z",
    fill: "url(#paint22_linear_618_80585)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.128 71.0731C242.062 71.0731 243.63 69.5053 243.63 67.5714C243.63 65.6374 242.062 64.0697 240.128 64.0697C238.194 64.0697 236.626 65.6374 236.626 67.5714C236.626 69.5053 238.194 71.0731 240.128 71.0731ZM240.128 73.6994C243.512 73.6994 246.256 70.9558 246.256 67.5714C246.256 64.187 243.512 61.4434 240.128 61.4434C236.743 61.4434 234 64.187 234 67.5714C234 70.9558 236.743 73.6994 240.128 73.6994Z",
    fill: "url(#paint23_linear_618_80585)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M231.522 227.029L246.282 210.757L248.505 212.773C250.662 214.73 251.954 217.463 252.096 220.372C252.237 223.281 251.218 226.127 249.261 228.284C247.305 230.441 244.571 231.732 241.662 231.874C238.754 232.016 235.908 230.996 233.751 229.04L231.527 227.023L231.522 227.029Z",
    fill: "#65C8DE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_618_80585",
    x: -0.00012207,
    y: 122.443,
    width: 100.219,
    height: 123.572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_618_80585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_618_80585",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_618_80585",
    x: 157,
    y: 0,
    width: 96.219,
    height: 64.3779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_618_80585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_618_80585",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_618_80585",
    x: 89.7798,
    y: 77.2233,
    width: 137.72,
    height: 137.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.33757
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_618_80585"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_618_80585",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_618_80585",
    x: 102.836,
    y: 148.643,
    width: 115.058,
    height: 52.5267,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.422,
    result: "effect1_foregroundBlur_618_80585"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_618_80585",
    x1: 126.817,
    y1: -20.9061,
    x2: 129.166,
    y2: 381.907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EE2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_618_80585",
    x1: 47.9998,
    y1: 46.4434,
    x2: 204,
    y2: 57.4434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_618_80585",
    x1: 43.4998,
    y1: 160.944,
    x2: 268.5,
    y2: 164.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_618_80585",
    x1: 66.5001,
    y1: 79.4436,
    x2: 187.5,
    y2: 79.4436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65C8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_618_80585",
    x1: 66.5001,
    y1: 112.139,
    x2: 187.5,
    y2: 112.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65C8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_618_80585",
    x1: 66.5001,
    y1: 144.834,
    x2: 187.5,
    y2: 144.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65C8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_618_80585",
    x1: 66.5002,
    y1: 177.531,
    x2: 187.5,
    y2: 177.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65C8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_618_80585",
    x1: 9.8915,
    y1: 200.611,
    x2: 144.478,
    y2: 211.665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_618_80585",
    x1: 161.892,
    y1: 37.7787,
    x2: 263.281,
    y2: 40.7116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCF3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_618_80585",
    x1: 76.3148,
    y1: 174.653,
    x2: 19.3148,
    y2: 174.653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_618_80585",
    x1: 76.2694,
    y1: 210.802,
    x2: 19.7593,
    y2: 210.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_618_80585",
    x1: 76.2694,
    y1: 191.802,
    x2: 19.7593,
    y2: 191.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_618_80585",
    x1: 61.8149,
    y1: 155.654,
    x2: 21.3149,
    y2: 155.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.243799,
    stopColor: "#D2F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BCBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_618_80585",
    x1: 199.505,
    y1: 198.017,
    x2: 214.405,
    y2: 181.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_618_80585",
    x1: 96.8603,
    y1: 112.894,
    x2: 220.949,
    y2: 113.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_618_80585",
    x1: 158.64,
    y1: 93.8984,
    x2: 211.225,
    y2: 230.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_618_80585",
    x1: 131.932,
    y1: 121.45,
    x2: 188.597,
    y2: 174.391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF698D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3868"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_618_80585",
    x1: 98.9524,
    y1: 212.141,
    x2: 141.249,
    y2: 212.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_618_80585",
    x1: 15.9523,
    y1: 20.1412,
    x2: 58.2491,
    y2: 20.4158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_618_80585",
    x1: 116.986,
    y1: 13.2719,
    x2: 129.323,
    y2: 13.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_618_80585",
    x1: 227.808,
    y1: 122.578,
    x2: 240.5,
    y2: 110.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_618_80585",
    x1: 20.6365,
    y1: 97.2477,
    x2: 32.8477,
    y2: 109.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_618_80585",
    x1: 187.637,
    y1: 218.248,
    x2: 199.848,
    y2: 230.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_618_80585",
    x1: 233.986,
    y1: 64.2719,
    x2: 246.323,
    y2: 64.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90E3F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65C8DE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReffrenceAd);
export default __webpack_public_path__ + "static/media/no_reffrence_ad.5c3cd54e89574b496fa9ab70a95cd3da.svg";
export { ForwardRef as ReactComponent };